import request from '@/utils/request'
let baseURL = '/mall-goods';

// 商城首页
export function mallGoods(data) {
  return request({
    url: '/api/search/v1',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
goodsCategorySysIdFirst (integer, optional): 平台商品一级分类ID（冗余） ,
goodsCategorySysIdSecond (integer, optional): 平台商品二级分类ID（冗余） ,
goodsCategorySysIdThird (integer, optional): 平台商品三级分类ID ,
goodsType (string): 商品类型：KNOWLEDGE-知识商品；JD_GOODS-京东商品；JD_BOOK-京东图书 = ['KNOWLEDGE', 'JD_GOODS', 'JD_BOOK'],
orderBy (string, optional): 排序字段：POPULARITY-综合热度（热门推荐）；SALES_VOLUME-销量；TIME-上架时间（最新）；PRICE-价格；PV-商品页浏览量；PERSONALIZED-个性化推荐（精选） = ['POPULARITY', 'SALES_VOLUME', 'TIME', 'PRICE', 'PV', 'PERSONALIZED'],
page (integer, optional),
query (string, optional): 检索词 ,
size (integer, optional),
sortOrder (string, optional): 顺序（大写）：ASC-升序；DESC-降序 = ['asc', 'desc']
}
*/

//获取省购店铺的商品列表

export function sgShopGoodsList(data) {
  return request({
    url: '/goods/user/v1/out/shop/goods',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
page (integer, optional),
shopId (integer): 店铺id ,
size (integer, optional)
}
* */


// 商品详情页
// 专栏详情
export function columnDetail(data) {
  return request({
    url: '/course/user/v1/getColumnDetail',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
  goodsId (integer): 商品id
}
*/


//课程详情(视频，音频)
export function courseDetail(data) {
  return request({
    url: '/course/user/v1/getCourseDetail',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
  goodsId (integer): 商品id
}
*/


// 直播详情
export function directDetail(data) {
  return request({
    url: '/course/user/v1/getDirectDetail',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
goodsId (integer): 商品id ,
inviteUserId (string, optional): 邀请用户ID ,
shopId (integer, optional): 店铺id（业务上必传，兼容旧版本APP做了可不传处理）
}
*/

// 用户学习列表
export function listMyRecentCourse(data) {
  return request({
    url: '/course/user/v1/listMyRecentCourse',
    method: 'post',
    baseURL,
    data
  })
}

// 用户直播列表
export function listMyLiveCourse(data) {
  return request({
    url: '/course/user/v1/listMyLiveCourse',
    method: 'post',
    baseURL,
    data
  })
}

// 获取商品分类
export function getClassify(data) {
  return request({
    url: '/goods/mch/v1/getClassify',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
  classifyGrade (integer, optional): 商品分类等级:1:一级分类 2.二级分类 3.三级分类 ,
  classifyId (integer, optional): 商品分类Id
}
* */

// 获取店铺商品列表
export function getShopHomeInfo(data) {
  return request({
    url: '/goods/user/v1/getShopHomeInfo',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
inviteUserId (string, optional): 邀请用户ID ,
page (integer, optional),
shopId (integer): 店铺id ,
size (integer, optional),
typeId (integer, optional), 查询类型： 1 全部  2 课程  3 专栏
}
* */




// 收藏商品列表
export function getCollectGoods(data) {
  return request({
    url: '/goods/user/v1/pageCollectGoods',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
goodsTypes (Array[string], optional): 商品类型：KNOWLEDGE-知识类；JD_GOODS-京东商品；JD_BOOK-京东图书（未传时默认查知识类） ,
page (integer, optional),
size (integer, optional)
}
* */


// 收藏商品
export function saveCollectGoods(data) {
  return request({
    url: '/goods/user/v1/saveCollectGoods',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
goodsId (integer): 收藏商品id ,
shopId (integer): 店铺id
}
* */



// 取消收藏商品
export function deleteCollectGoods(data) {
  return request({
    url: '/goods/user/v1/deleteCollectGoods',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
goodsId (integer): 收藏商品id ,
shopId (integer): 店铺id
}
* */


// 获取投诉理由列表
export function getGoodsComplaintReasonTree(data) {
  return request({
    url: '/goods/user/v1/getGoodsComplaintReasonTree',
    method: 'post',
    baseURL,
    data
  })
}
/*
{}
* */


// 投诉商品
export function complaintGoods(data) {
  return request({
    url: '/course/user/v1/complaintGoods',
    method: 'post',
    baseURL,
    data
  })
}
/*
课程商品投诉请求体 {
complaintPictureList (Array[投诉理由照片], optional): 投诉图片/截图 ,
goodsComplaintReasonId (integer): 投诉理由id ,
goodsId (integer): 商品id ,
goodsVersionNo (integer): 快照版本号 ,
reason (string, optional): 投诉内容 ,
tel (string, optional): 投诉人手机号
}
投诉理由照片 {
complaintReasonContent (string, optional): 照片路径
}
* */


//获取店铺会员赠送的商品
export function shopGiftGoods(data) {
  return request({
    url: '/goods/user/v1/shopGift/goods',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
productIds (Array[integer]): 货品ID列表 ,
}

{
  "productIds": [
    0
  ]
}
* */


// jd 京东相关接口

// 获取京东商品详情
export function getJdGoodsDetail(data) {
  return request({
    url: '/jd/user/v1/getJdGoodsDetail',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
goodsId (integer, optional): 京东商品ID（商品ID和SKU二传一） ,
inviteUserId (string, optional): 邀请用户ID（点击分享链接进来时需传） ,
jdSku (integer, optional): 京东sku（商品ID和SKU二传一） ,
shopId (integer): 店铺id
}
* */

// 平台商品分类分级查询
export function listCategorySys(data) {
  return request({
    url: '/category/v1/listCategorySys',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
categorySystem (string, optional): 分类体系：NORMAL_MALL：普通商城；KNOWLEDGE_MALL-知识商城 ,
parentId (integer, optional): 平台商品分类ID,查1级传空
}
* */

// 平台商品分类分级查询
export function listChildTrees(params) {
  return request({
    url: '/category/v1/listChildTrees',
    method: 'get',
    baseURL,
    params
  })
}
/*
parentId	(required)   parentId   query  	long
* */





// 根据货品ID集合查询货品基本信息列表
export function listProducts(data) {
  return request({
    url: '/goods/user/v1/listProducts',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
productIds (Array[integer]): 货品ID集合
}
* */



// 新增商品评价
export function addEvaluated(data) {
  return request({
    url: '/comment/v1/add',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
list (Array[GoodsCommentVO], optional): 评论集合
}

GoodsCommentVO {
commentInfo (string, optional): 评价内容 ,
descriptionScore (number): 描述相符评分 ,
files (Array[string], optional): 图片集合 ,
goodsId (integer): 商品ID ,
logisticScore (number, optional): 物流服务评分 ,
orderMergeId (integer): 组合订单ID ,
serviceScore (number, optional): 服务态度评价 ,
shopId (integer): 店铺ID
}
* */

// 查看商品评价列表
export function evaluatedList(data) {
  return request({
    url: '/comment/v1/list',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
goodsId (integer, optional): goodsId ,
page (integer, optional),
shopId (integer, optional): shopId ,
size (integer, optional)
}
* */


// 商品反馈
export function goodsConsult(data) {
  return request({
    url: '/consult/v1/goodsConsult',
    method: 'post',
    baseURL,
    data
  })
}

// --   2020.06.24 ----------------------------
// 获取店铺带货视频列表
export function shopVideos(params) {
  return request({
    url: '/video/v1/shopVideos',
    method: 'get',
    baseURL,
    params
  })
}
// 获取店铺带货视频详情
export function shopVideoDetail(params) {
  return request({
    url: '/video/v1/shopVideo/detail',
    method: 'get',
    baseURL,
    params
  })
}